// actions/offerActions.js
import axios from "../helpers/axios";
import { socket } from "../containers/ChatPage/socket";
import { offerConstants } from "./constants";

// === LIST ===
export const listOffers = (params = {}) => {
    return async (dispatch) => {
        dispatch({ type: offerConstants.LIST_REQUEST });
        try {
            const qs = new URLSearchParams(params).toString();
            // сервер должен отдавать { items, total }
            const res = await axios.get(`/offers${qs ? `?${qs}` : ""}`);
            if (res.status === 200 && res.data && Array.isArray(res.data.items)) {
                dispatch({ type: offerConstants.LIST_SUCCESS, payload: { items: res.data.items, total: res.data.total || res.data.items.length } });
            } else {
                dispatch({ type: offerConstants.LIST_FAILURE });
            }
        } catch {
            dispatch({ type: offerConstants.LIST_FAILURE });
        }
    };
};

// === GET ONE ===
export const getOffer = (offerId) => {
    return async (dispatch) => {
        dispatch({ type: offerConstants.GET_REQUEST });
        try {
            const res = await axios.get(`/offers/${offerId}`);
            if (res.status === 200 && res.data) {
                dispatch({ type: offerConstants.GET_SUCCESS, payload: res.data });
            } else {
                dispatch({ type: offerConstants.GET_FAILURE });
            }
        } catch {
            dispatch({ type: offerConstants.GET_FAILURE });
        }
    };
};

// === CREATE ===
export const createOffer = (payload) => {
    return async (dispatch) => {
        try {
            const res = await axios.post(`/offers`, payload);
            if (res.status === 201 && res.data) {
                dispatch({ type: offerConstants.CREATE_SUCCESS, payload: res.data });
                return res.data;
            }
            throw new Error();
        } catch {
            // по желанию: CREATE_FAILURE
            return null;
        }
    };
};

// === DELETE ===
export const deleteOffer = (offerId) => {
    return async (dispatch) => {
        dispatch({ type: offerConstants.DELETE_REQUEST });
        try {
            const res = await axios.delete(`/offers/${offerId}`);
            if (res.status === 200) {
                dispatch({ type: offerConstants.DELETE_SUCCESS, payload: { offerId } });
            } else {
                dispatch({ type: offerConstants.DELETE_FAILURE });
            }
        } catch {
            dispatch({ type: offerConstants.DELETE_FAILURE });
        }
    };
};

// === FINALIZE (PDF) ===
export const finalizeOffer = (offerId, userId) => {
    return async (dispatch) => {
        dispatch({ type: offerConstants.FINALIZE_REQUEST });
        try {
            const res = await axios.post(`/offers/${offerId}/finalize`, { userId });
            if (res.status === 200 && res.data) {
                dispatch({ type: offerConstants.FINALIZE_SUCCESS, payload: res.data });
                return res.data;
            }
            throw new Error();
        } catch (error) {
            const serverMessage =
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.message ||
                "Не удалось сформировать PDF";

            dispatch({
                type: offerConstants.FINALIZE_FAILURE,
                payload: { error: serverMessage },
            });

            return { ok: false, error: serverMessage };
        }
    };
};

// === SOCKETS ===
export const subscribeOfferSockets = (offerId, userId) => {
    return (dispatch) => {
        socket.emit("offer:join", { offerId, userId }, (ack) => {
            // no-op
        });

        const onSnapshot = (payload) => dispatch({ type: offerConstants.SOCKET_SNAPSHOT, payload });
        const onUpdated = (payload) => dispatch({ type: offerConstants.SOCKET_UPDATED, payload });
        const onLocked = (payload) => dispatch({ type: offerConstants.SOCKET_LOCKED, payload });
        const onUnlocked = (payload) => dispatch({ type: offerConstants.SOCKET_UNLOCKED, payload });
        const onPresence = (payload) => dispatch({ type: offerConstants.SOCKET_PRESENCE, payload });

        socket.on("offer:snapshot", onSnapshot);
        socket.on("offer:updated", onUpdated);
        socket.on("offer:locked", onLocked);
        socket.on("offer:unlocked", onUnlocked);
        socket.on("offer:presence", onPresence);

        return () => {
            socket.off("offer:snapshot", onSnapshot);
            socket.off("offer:updated", onUpdated);
            socket.off("offer:locked", onLocked);
            socket.off("offer:unlocked", onUnlocked);
            socket.off("offer:presence", onPresence);
            socket.emit("offer:leave", { offerId, userId });
        };
    };
};

export const lockField = (offerId, field, userId) => () => {
    socket.emit("offer:lock", { offerId, field, userId });
};

export const unlockField = (offerId, field) => () => {
    socket.emit("offer:unlock", { offerId, field });
};

export const updateOfferSocket = (offerId, patch, userId) => {
    return (dispatch) => new Promise((resolve) => {
        const send = (attempt = 0) => {
            socket.emit("offer:update", { offerId, patch, userId }, (ack) => {
                if (
                    !ack?.ok &&
                    ack?.error === "Too many updates" &&
                    attempt < 1
                ) {
                    setTimeout(() => send(attempt + 1), 180);
                    return;
                }

                if (ack?.ok) {
                    const nextPatch = ack.status
                        ? { ...patch, status: ack.status }
                        : patch;

                    dispatch({
                        type: offerConstants.SOCKET_UPDATED,
                        payload: {
                            offerId,
                            patch: nextPatch,
                            totals: ack.totals,
                            userId,
                        },
                    });
                }

                resolve(ack);
            });
        };

        send();
    });
};

export const presence = (offerId, userId, state) => () => {
    socket.emit("offer:presence", { offerId, userId, state });
};
